module.exports = __webpack_public_path__ + "img/Number=67.acdcf4dc.png";